import { t } from 'i18next';

import { validDomain, validEmail } from '../../../../../utils';

export function validateEmailInput(value: string, values?: Map<string, boolean>) {
  const _value = value.trim().toLowerCase();

  if (_value.includes('*')) {
    if (!_value.startsWith('*@')) {
      return t('manager.webcastSetup.eventAccess.whitelistModal.errorMessages.email.wildcardNotAtTheBeginning');
    }

    if (!validDomain(_value)) {
      return t('manager.webcastSetup.eventAccess.whitelistModal.errorMessages.email.invalidEmail');
    }
  }

  if (!_value.includes('*@') && !validEmail(_value)) {
    return t('manager.webcastSetup.eventAccess.whitelistModal.errorMessages.email.invalidEmail');
  }

  if (values?.has(_value)) {
    return t('manager.webcastSetup.eventAccess.whitelistModal.errorMessages.email.duplicatedEmail');
  }
}
